import { atom } from 'recoil';

export const currentUserState = atom({
  key: 'currentUserState',
  default: {
    getCurrentUser: (null as unknown) as () => any,
    setCurrentUser: (null as unknown) as (session: any) => void,
  },
});
